import {useIsFeatureActive} from '@aboutyou/feature-flags';
import {lazy} from '@aboutyou/lazy-imports';
import React from 'react';

const InitializeAbTestsConditionallyLazy = lazy(() =>
  import('./InitializeAbTestsConditionally.eager').then(mod => ({
    default: mod.InitializeAbTestsConditionally,
  })),
);

export const InitializeAbTestsConditionally = () => {
  const isEnabled = useIsFeatureActive('ab_test_setup_enabled').isActive;
  if (!isEnabled) {
    return null;
  }

  return <InitializeAbTestsConditionallyLazy />;
};
